import TandemPayPage from './TandemPayPage';

export default TandemPayPage;
